export enum DiseasesEnum {
	DENGUE = 1,
	SIFILIS = 2,
	HANSEN = 3,
	TUBERCULOSIS = 4,
}
